import srMessages from '../locales/sr_RS';

const SrLang = {
  messages: {
    ...srMessages,
  },
  locale: 'sr-RS',
};
export default SrLang;
